export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-background-100 via-background-100 to-accent-500/5 rounded-2xl p-8 md:p-12 border border-background-200/30 overflow-hidden relative">
            <div className="absolute top-0 right-0 w-64 h-64 bg-primary-500/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-accent-500/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>

            <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8 md:gap-12">
              <div className="flex-1 text-center lg:text-left">
                <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/15 text-primary-500 text-xs font-medium mb-4">
                  <i className="ri-smartphone-line"></i>
                  <span>移动端专属体验</span>
                </div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                  随时随地 · 高清在线
                </h2>
                <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                  8090影院移动端已全面适配，手机浏览器直接访问即可畅享高清电影在线观看体验。无需下载APP，不占存储空间，同样支持4K超清画质、多线路切换和不缓冲影院级播放。
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                  <a
                    href="#hero"
                    className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm transition-all duration-200 cursor-pointer whitespace-nowrap text-center"
                  >
                    <i className="ri-play-circle-fill mr-2"></i>
                    立即观影
                  </a>
                  <a
                    href="#features"
                    className="w-full sm:w-auto px-8 py-3 bg-background-50/80 hover:bg-background-50 text-foreground-700 hover:text-foreground-950 font-medium rounded-lg text-sm transition-all duration-200 cursor-pointer whitespace-nowrap text-center border border-background-300/30"
                  >
                    <i className="ri-information-line mr-2"></i>
                    了解更多
                  </a>
                </div>
              </div>

              <div className="flex-shrink-0 relative">
                <div className="absolute inset-0 bg-gradient-to-r from-primary-500/10 via-accent-500/10 to-primary-500/10 rounded-2xl blur-xl"></div>
                <div className="relative w-56 h-[400px] rounded-2xl border-2 border-background-300/40 overflow-hidden bg-background-50 shadow-lg">
                  <div className="h-8 bg-background-100 flex items-center justify-center border-b border-background-200/30">
                    <div className="w-20 h-1 rounded-full bg-background-300"></div>
                  </div>
                  <div className="p-3 space-y-2.5">
                    <div className="h-32 bg-background-100 rounded-lg flex items-center justify-center">
                      <div className="w-10 h-10 rounded-full bg-accent-500/20 flex items-center justify-center">
                        <i className="ri-play-fill text-accent-400 text-xl ml-0.5"></i>
                      </div>
                    </div>
                    <div className="h-2.5 bg-background-100 rounded w-3/4"></div>
                    <div className="h-2 bg-background-100 rounded w-1/2"></div>
                    <div className="space-y-2 mt-3">
                      <div className="h-10 bg-background-100 rounded-lg"></div>
                      <div className="h-10 bg-background-100 rounded-lg"></div>
                      <div className="h-10 bg-background-100 rounded-lg"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}